export const setFormControlError = (errors: { [key: string]: any }) => [() => errors];
